import { render, staticRenderFns } from "./component-img-txt.vue?vue&type=template&id=8001e5b2&scoped=true&"
import script from "./component-img-txt.vue?vue&type=script&lang=js&"
export * from "./component-img-txt.vue?vue&type=script&lang=js&"
import style0 from "./component-img-txt.vue?vue&type=style&index=0&id=8001e5b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8001e5b2",
  null
  
)

export default component.exports